import { Box, useColorModeValue, Text, Spinner, Flex } from "@chakra-ui/react";
import { formaterDocument } from "utils/formaterDocumente";
import { useClients } from "hooks/ClientsHook";
import { useQuery } from "react-query";

interface CardsbasicInfoClientProps {
  id: number;
}

export default function CardBasicInfoClient({ id }: CardsbasicInfoClientProps) {
  const boxBg = useColorModeValue("#ffff", "#111c44");

  const { findCardClientsInformations } = useClients();
  const { data, error, isLoading } = useQuery(
    ["findCardClientsInformations", id],
    () => findCardClientsInformations(id),
    {
      retry: false,
    }
  );

  return (
    <Box
      display="flex"
      padding={5}
      width="100%"
      height={"auto"}
      borderRadius="30px"
      backgroundColor={boxBg}
      flexDir="column"
      gap={1}
    >
      <Text align="center" fontWeight={800} fontSize={21} textAlign="center">
        Informações do Cliente
      </Text>

      {isLoading ? (
        <Flex align="center" justify="center" p={8}>
          <Spinner size="xl" />
        </Flex>
      ) : error ? (
        <Box p={4} color="red.500" textAlign="center">
          <Text fontSize="sm">{String(error)}</Text>
        </Box>
      ) : data && data.INFOS_BASICAS ? (
        <>
          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Razão Social:
            </Box>
            {data.INFOS_BASICAS.NOME}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Nome Fantasia:
            </Box>
            {data.INFOS_BASICAS.NOME_FANTASIA}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Documento:
            </Box>
            {formaterDocument(data.INFOS_BASICAS.DOCUMENTO)}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Cidade/UF:
            </Box>
            {data.INFOS_BASICAS.CIDADE} - {data.INFOS_BASICAS.UF}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Endereço:
            </Box>
            {data.INFOS_BASICAS.CIDADE} - {data.INFOS_BASICAS.NUMERO}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Bairro:
            </Box>
            {data.INFOS_BASICAS.BAIRRO}
          </Text>

          <Text p={2}>
            <Box as="span" mr={1} fontWeight={800} fontSize="lg">
              Regime:
            </Box>
            {data.INFOS_BASICAS.REGIME_TRIBUTARIO}
          </Text>
        </>
      ) : (
        <Box p={4} textAlign="center">
          <Text>Nenhum dado disponível</Text>
        </Box>
      )}
    </Box>
  );
}
